import cn from 'classnames';
import styles from './Counter.module.scss';
import { ChangeEvent, useEffect, useState } from 'react';

type CounterProps = {
  className?: string;
  min: number;
  max: number;
  value: number;
  label?: string;
  onChange: (value: number) => void;
};

export function Counter({
  className,
  min,
  max,
  value,
  label = '',
  onChange,
}: CounterProps) {
  const inputClassName = cn(styles.input, className);
  const [prevValue, setPrevValue] = useState(value);
  const [inputValue, setInputValue] = useState(`${label} ${value}`);

  useEffect(() => {
    setInputValue(`${label} ${value}`);
  }, [value, label]);

  const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);

    const parsedValue = Number(newValue.replace(/\D/g, ''));
    if (!parsedValue && parsedValue !== 0) return;

    if (parsedValue > max) {
      onChange(max);
      return;
    }

    if (parsedValue < min) {
      onChange(min);
      return;
    }

    onChange(parsedValue);
  };

  const handleFocus = () => {
    setPrevValue(value);
    setInputValue('');
  };

  const handleBlur = () => {
    if (!inputValue) {
      onChange(prevValue);
      setInputValue(`${label} ${prevValue}`);
      return;
    }
    setInputValue(`${label} ${value}`);
  };

  return (
    <input
      className={inputClassName}
      min={min}
      max={max}
      value={inputValue}
      onChange={handleChangeValue}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
}
